export const environment = {
    production: true,
    appRoot: 'https://lina.demo.foxway.dev/',
    apiRoot: 'https://lina.demo.foxway.dev/api/',
    depRoot: 'https://lina.demo.foxway.dev:8005/api/',
    fileServiceRoot: 'https://d1bv9cz53xa6po.cloudfront.net/',
    webSocketUrlCqrs: 'https://lina.demo.foxway.dev:8001',
    webSocketUrlLina: 'https://lina.demo.foxway.dev',
    resetPasswordUrl: 'https://lina.demo.foxway.dev/account/request_reset/',
    cookieDomain: '.demo.foxway.dev',
    environment: 'Demo',
    gsxLogin: 'https://login-partner-connect-uat.apple.com',
    msalConfig: {
      auth: {
        clientId: '34011fbd-2c04-4d0c-86d7-c8ad1282960b', 
        authority: 'https://login.microsoftonline.com/89d21db8-1069-440d-8c8c-751a0302980c/', 
        knownAuthorities: ['foxwayb2ctest.b2clogin.com'],
        redirectUri: 'https://lina.demo.foxway.dev/auth/ssologin',      
      },
      loginScopes: ["https://foxwayb2ctest.onmicrosoft.com/lina/login"]
    }   
  };
